import { Crew } from '@src/main/modules/ibdp/domain/crew.interface';
import { CrewEntity } from '@src/main/modules/ibdp/infrastructure/crew.entity';

export function toCrew(entity: CrewEntity): Crew {
  return {
    name: entity.nombre,
    surnames: entity.apellidos,
    payrollNumber: entity.nomina,
  };
}

export function fromCrew(model: Crew): CrewEntity {
  return {
    nombre: model.name,
    apellidos: model.surnames,
    nomina: model.payrollNumber,
  };
}
